export class Annotation {
    constructor(type, canvasElement, toolSize, coords, options, zoomOptions, orientation, id) {
        this.id = id
        this.type = type
        this.canvasElement = canvasElement
        this.toolSize = toolSize
        this.coords = coords
        this.canvas = null
        this.options = options
        this.zoomOptions = zoomOptions
        this.orientation = orientation
        this.hitboxCanvas = null
        this.mouseDownEvent = false
        this.lastEvent = ""
        this.selected = false
        this.offset = [0, 0]
        this.hitbox = {
            x1: 0,
            y1: 0,
            x4: 0,
            y4: 0
        }
        this.zoomScale = 50
        this.setOptionsDefaults()
        // this.setHitbox()
        
    }

    getType() {
        return this.type
    }

    setOptionsDefaults() {
        if (this.options.color == null || this.options.color == "") {
            this.options.color = "#000"
        }
        if (this.options.lineThickness == null || this.options.lineThickness == "") {
            this.options.lineThickness = "5"
        }
        if (this.options.filled == null || this.options.color == "") {
            this.options.filled = false
        }
    }

    drawHitbox() {
        this.canvas.style.border = "1px dashed blue"
        this.canvas.style.zIndex = 500
        this.canvas.classList.add("selected")
        this.selected = true
    }

    removeHitbox() {
        this.canvas.style.border = "none"
        this.canvas.style.zIndex = 499
        this.canvas.classList.remove("selected")
        this.selected = false
    }

    removeAnnotation() {
        var ctx = this.canvas.getContext('2d')
        ctx.clearRect(this.hitbox.x1-5, this.hitbox.y1-5, this.hitbox.x4 - this.hitbox.x1+10, this.hitbox.y4 - this.hitbox.y1+10);
    }

    createNewCanvas() {
        var canvas = document.createElement('canvas')
        canvas.id = "canvas_element_" + this.id
        canvas.style.pointerEvents = "none"
        if (this.type == "square") {
            canvas.className = this.type
            canvas.width = (parseInt(this.toolSize[0]) + 10) + (this.zoomOptions.zoom * this.zoomOptions.scale) * this.zoomScale
            canvas.height = (parseInt(this.toolSize[1]) + 10) + (this.zoomOptions.zoom * this.zoomOptions.scale) * this.zoomScale
            canvas.style.left = (parseInt(this.coords[0]) - parseInt(this.toolSize[0]/2)) + (this.zoomOptions.pageWidthIncreasePerZoom/2 * this.zoomOptions.zoom) + "px"
            canvas.style.top = (parseInt(this.coords[1]) - parseInt(this.toolSize[1]/2)) + "px"
            canvas.style.zIndex = 500
            canvas.style.position = "absolute"
            canvas.tabIndex = -1
            canvas.style.outline = "none"
            // canvas.style.border = "1px solid #f0f"
        } else if (this.type == "circle") {
            canvas.className = this.type
            canvas.width = parseInt(this.toolSize[0]) * 2 + 10
            canvas.height = parseInt(this.toolSize[0]) * 2 + 10
            canvas.style.left = (parseInt(this.coords[0]) - parseInt(this.toolSize[0])) + "px"
            canvas.style.top = (parseInt(this.coords[1]) - parseInt(this.toolSize[0])) + "px"
            canvas.style.zIndex = 500
            canvas.style.position = "absolute"
            canvas.tabIndex = -1
            canvas.style.outline = "none"
            // canvas.style.border = "1px solid #f0f"
        } else if (this.type == "drawing") {
            canvas.className = this.type
            
            var x = this.coords.map(function(coord) {return coord[0]});
            var y = this.coords.map(function(coord) {return coord[1]});

            var min_coords = {
                x : Math.min.apply(null, x),
                y : Math.min.apply(null, y)
            }
            var max_coords = {
                x : Math.max.apply(null, x),
                y : Math.max.apply(null, y)
            }

            this.setHitboxCoords(min_coords, max_coords)

            canvas.width = max_coords.x - min_coords.x + 5
            canvas.height = max_coords.y - min_coords.y + 5

            canvas.style.left = min_coords.x + "px"
            canvas.style.top = min_coords.y + "px"
            canvas.style.zIndex = 500
            canvas.style.position = "absolute"
            canvas.tabIndex = -1
            canvas.style.outline = "none"

        } else if (this.type == "text") {
            var textBoundRect = this.getTextBoundRect(this.options.text)
            canvas.className = this.type
            canvas.width = textBoundRect.width + 5
            canvas.height = textBoundRect.height + 5
            canvas.style.left = parseInt(this.coords[0]) + "px"
            canvas.style.top = parseInt(this.coords[1]) + "px"
            canvas.style.zIndex = 500
            canvas.style.position = "absolute"
            canvas.tabIndex = -1
            canvas.style.outline = "none"
            canvas.style.border = "1px dashed blue"
            this.selected = true
        }
        
        this.canvas = canvas
    }

    setHitboxCoords(min_coords, max_coords) {
        if (min_coords == null || max_coords == null) {
            var x = this.coords.map(function(coord) {return coord[0]});
            var y = this.coords.map(function(coord) {return coord[1]});
            min_coords = {
                x : Math.min.apply(null, x),
                y : Math.min.apply(null, y)
            }
            max_coords = {
                x : Math.max.apply(null, x),
                y : Math.max.apply(null, y)
            }
        }
        this.hitbox.x1 = min_coords.x
        this.hitbox.y1 = min_coords.y
        this.hitbox.x4 = max_coords.x
        this.hitbox.y4 = max_coords.y
    }

    getTextBoundRect(text) {     
        var textSpan = document.createElement("span")
        document.body.appendChild(textSpan)
     
        textSpan.style.font = "Arial"
        textSpan.style.fontSize = 16 + "pt"
        textSpan.style.height = 'auto'
        textSpan.style.width = 'auto'
        textSpan.style.position = 'absolute'
        textSpan.style.whiteSpace = 'no-wrap'
        textSpan.innerHTML = text
     
        var width = Math.ceil(textSpan.clientWidth)
        var height = Math.ceil(textSpan.clientHeight)
     
        document.body.removeChild(textSpan)
        return {"width":width, "height":height}
    }

    appendNewCanvas() {
        this.canvasElement.appendChild(this.canvas)
    }

    drawSquare() {
        this.createNewCanvas()
        let ctx = this.canvas.getContext("2d")
        ctx.beginPath();
        
        if (this.options.color) ctx.strokeStyle = this.options.color
        if (this.options.lineThickness) ctx.lineWidth = parseInt(this.options.lineThickness)

        ctx.fillStyle = this.options.filled ? this.options.color : 'rgba(255, 255, 255, 0)';
        ctx.rect(5, 5, parseInt(this.toolSize[0]) + (this.zoomOptions.zoom * this.zoomOptions.scale) * this.zoomScale, parseInt(this.toolSize[1]) + (this.zoomOptions.zoom * this.zoomOptions.scale) * this.zoomScale) // the 5, 5 is padding on the canvas - gives room for hitbox - top left (x,y)
        ctx.fill()
        
        ctx.stroke()
        this.appendNewCanvas()
    }

    drawCircle() {
        this.createNewCanvas()
        let ctx = this.canvas.getContext("2d")
        ctx.beginPath();
        
        if (this.options.color) ctx.strokeStyle = this.options.color
        if (this.options.lineThickness) ctx.lineWidth = parseInt(this.options.lineThickness)

        ctx.fillStyle = this.options.filled ? this.options.color : 'rgba(255, 255, 255, 0)'
        ctx.arc(parseInt(this.toolSize[0]) + 5, parseInt(this.toolSize[0]) + 5, this.toolSize[0], 0, 2 * Math.PI) // 5 padding from the center, gives room for hitbox
        ctx.fill()

        ctx.stroke()
        this.appendNewCanvas()
    } 

    drawDrawing() {
        this.createNewCanvas()
        let ctx = this.canvas.getContext("2d")

        if (this.options.color) ctx.fillStyle = this.options.color

        var drawingLastX = this.coords[0][0]
        var drawingLastY = this.coords[0][1]

        var x = this.coords.map(function(coord) {return coord[0]});
        var y = this.coords.map(function(coord) {return coord[1]});

        var min_coords = {
            x : Math.min.apply(null, x),
            y : Math.min.apply(null, y)
        }
        
        for (var coord of this.coords) {

            var x1 = coord[0],
                x2 = drawingLastX,
                y1 = coord[1],
                y2 = drawingLastY;

            var newX1 = x1 - min_coords.x
            var newY1 = y1 - min_coords.y
            
            var newX2 = x2 - min_coords.x
            var newY2 = y2 - min_coords.y;

            var steep = (Math.abs(newY2 - newY1) > Math.abs(newX2 - newX1));
            var x, y = 0
            if (steep) {
                x = newX1;
                newX1 = newY1;
                newY1 = x;
            
                y = newY2;
                newY2 = newX2;
                newX2 = y;
                }
            if (newX1 > newX2) {
                x = newX1;
                newX1 = newX2;
                newX2 = x;
            
                y = newY1;
                newY1 = newY2;
                newY2 = y;
            }

            var dx = newX2 - newX1,
                dy = Math.abs(newY2 - newY1),
                error = 0,
                de = dy / dx,
                yStep = -1,
                y = newY1;

            if (newY1 < newY2) {
                yStep = 1;
            }

            var lineThickness = (this.options.lineThickness != null ? parseInt(this.options.lineThickness) : 5) - Math.sqrt((newX2 - newX1) * (newX2 - newX1) + (newY2 - newY1) * (newY2 - newY1)) / 10;
            if (lineThickness < 1) {
                lineThickness = 1;
            }

            for (var x = newX1; x < newX2; x++) {
                if (steep) {
                    ctx.fillRect(y, x, lineThickness, lineThickness);
                } else {
                    ctx.fillRect(x, y, lineThickness, lineThickness);
                }
            
                error += de;
                if (error >= 0.5) {
                    y += yStep;
                    error -= 1.0;
                }
            }

            drawingLastX = coord[0];
            drawingLastY = coord[1];
        }

        this.appendNewCanvas()
    }

    drawText() {
        this.createNewCanvas()
        let ctx = this.canvas.getContext("2d")

        ctx.font = "16px Arial"
        ctx.fillStyle = "black"
        ctx.fillText(this.options.text, 2, 20)

        this.appendNewCanvas()
    }

    redraw() {
        this.canvas = null
        if (this.type == "square") {
            this.drawSquare()
        } else if (this.type == "circle") {
            this.drawCircle()
        } else if (this.type == "drawing") {
            this.drawDrawing()
        } else if (this.type == "text") {
            this.drawText()
        }
    }

    rotate(rotation) {
        let cBound = this.canvasElement.getBoundingClientRect()
        this.coords = this.coords.map(coord => this.rotateFunction(cBound.left + (cBound.width / 2), cBound.top + (cBound.height / 2), coord[0], coord[1], rotation))
        this.canvas.remove()
        this.drawDrawing()
    }

    rotateFunction(cx, cy, x, y, angle) {
        var radians = (Math.PI / 180) * angle,
            cos = Math.cos(radians),
            sin = Math.sin(radians),
            nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
            ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
        return [nx, ny];
    }

    hide() {
        this.canvas.style.display = "none"
    }

    show() {
        this.canvas.style.display = "unset"
    }
    
}
